import { jsx as _jsx } from "react/jsx-runtime";
import { Icon } from "../Icon";
import { Box } from "./styles";
export default function CheckboxRoot({ id, size, disabled, isChecked, onClick, }) {
    return (_jsx(Box, { id: id, disabled: disabled, onClick: disabled ? undefined : onClick, size: size, children: isChecked && (_jsx(Icon, { name: "check", size: size === "small" ? "12px" : "16px", color: disabled ? "--text-disable" : undefined })) }));
}
//# sourceMappingURL=CheckboxRoot.js.map